import Cookies from 'js-cookie';
const pubSub = require('./util/pubsub');
const request = require('request');
const firebase = require("firebase");
// Required for side-effects
require("firebase/firestore");

class BackendClient {

    constructor() {

        let config = {

            apiKey: "AIzaSyBRz9-xfnKmN14bWPh5cbcicpCXjnN3WRs",
            authDomain: "firestoretest-5e731.firebaseapp.com",
            databaseURL: "https://firestoretest-5e731.firebaseio.com",
            projectId: "firestoretest-5e731",
            storageBucket: "firestoretest-5e731.appspot.com",
            messagingSenderId: "651575861314"
        };

        firebase.initializeApp(config);
        this.f = firebase;
        this.a = firebase.auth();
        this.fs = firebase.firestore();

        this.action = this.action.bind(this);
        this.createRoom = this.createRoom.bind(this);
        this.joinRoom = this.joinRoom.bind(this);
        this.leaveRoom = this.leaveRoom.bind(this);
        this.getUserDisplayName = this.getUserDisplayName.bind(this);
    }

    action(path, params, handler) {

        return this.a.currentUser.getIdToken()
                .then(idToken => {

                    if (params == null || params === undefined) {
                        params = {};
                    }

                    // Append token to form
                    params['token'] = idToken;

                    var requestParams = {
                        url: `https://us-central1-firestoretest-5e731.cloudfunctions.net/${path}`,
                        form: params
                    };

                    var requestHandler = (err, res, bod) => {

                        if (err === null && res.statusCode >= 400) {

                            err = { code: res.statusCode, message: bod };
                        }

                        if (handler) {
                            handler(err, res, bod);
                        }
                    };

                    request.post(requestParams, requestHandler);
                })
                .catch(error => {
                    console.error('Error obtaining ID token', error);
                });
    }

    createRoom(roomName, displayName, ruleStuck, rulePoints) {

        pubSub.pub(pubSub.EVENT_REQUEST_START);
        
        var params = {
            roomName: roomName,
            userName: displayName,
            ruleStuck: ruleStuck,
            rulePoints: rulePoints
        };

        console.debug('Creating room...', params);

        return this.action('createRoom', params, (err, res, bod) => {

            pubSub.pub(pubSub.EVENT_REQUEST_END);

            if (err) {
                console.error('Error creating room.', err);
                pubSub.pub(pubSub.EVENT_REQUEST_ERROR, err);
            } else {
                console.debug('Created room.');
            }
        });
    }

    leaveRoom() {

        pubSub.pub(pubSub.EVENT_REQUEST_START);

        console.debug('Leaving room...');

        return this.action('leaveRoom', null, (err, res, bod) => {

            pubSub.pub(pubSub.EVENT_REQUEST_END);

            if (err) {
                console.error('Error leaving room.', err);
                pubSub.pub(pubSub.EVENT_REQUEST_ERROR, err);
            } else {
                console.debug('Left room.');
            }
        });
    }

    joinRoom(roomId, seatIndex, displayName) {

        pubSub.pub(pubSub.EVENT_REQUEST_START);

        var params = {
            roomId: roomId,
            seatIndex: seatIndex,
            userName: displayName
        };

        console.debug('Joining room...', params);

        return this.action('joinRoom', params, (err, res, bod) => {

            pubSub.pub(pubSub.EVENT_REQUEST_END);

            if (err) {
                console.error('Error joining room.', err);
                pubSub.pub(pubSub.EVENT_REQUEST_ERROR, err);
            } else {
                console.debug('Joined room.');
            }
        });
    }

    setUpUser(displayName) {

        var params = {
            displayName: displayName
        };

        console.debug('Setting up user...');
        
        return this.action('setUpUser', params, (err, res, bod) => {

            pubSub.pub(pubSub.EVENT_REQUEST_END);

            if (err) {
                console.error('Error setting up user.', err);
                pubSub.pub(pubSub.EVENT_REQUEST_ERROR, err);
            } else {
                console.debug('User set up.');
            }
        });
    }

    updatePublicInfo(newDisplayName) {

        pubSub.pub(pubSub.EVENT_REQUEST_START);

        var params = {
            displayName: newDisplayName
        };

        console.debug('Updating public info...');

        return this.action('updatePublicInfo', params, (err, res, bod) => {

            pubSub.pub(pubSub.EVENT_REQUEST_END);

            if (err) {
                console.error('Error updating public info.', err);
                pubSub.pub(pubSub.EVENT_REQUEST_ERROR, err);
            } else {
                console.debug('Updated public info.');
            }
        });
    }

    pass(room, seat) {

        pubSub.pub(pubSub.EVENT_REQUEST_START);

        var params = {
            room: room,
            seat: seat
        };

        console.debug('Passing...', params);

        return this.action('pass', params, (err, res, bod) => {

            pubSub.pub(pubSub.EVENT_REQUEST_END);

            if (err) {
                console.error('Error passing.', err);
                pubSub.pub(pubSub.EVENT_REQUEST_ERROR, err);
            } else {
                console.debug('Passed.');
            }
        });
    }

    playTile(a, b, room, seat, end) {

        pubSub.pub(pubSub.EVENT_REQUEST_START);
        
        var params = {
            a: a,
            b: b,
            room: room,
            seat: seat,
            end: end
        };

        console.debug(`Playing [${a}|${b}]...`, params);

        return this.action('playTile', params, (err, res, bod) => {

            pubSub.pub(pubSub.EVENT_REQUEST_END);

            if (err) {
                pubSub.pub(pubSub.EVENT_REQUEST_ERROR, err);
            } else {
                console.debug('Played tile.');
            }
        });
    }

    setUserDisplayName(uid, displayName) {
        
        const data = { displayName };

        return this.fs.doc(`/users/${uid}`).update(data);
    }

    getUserDisplayName(uid, forceFetch = false) {

        const dis = this;
        const key = `dn-${uid}`;

        return new Promise(function(resolve, reject) {

            let val = Cookies.get(key);

            // If no forceFetch and cached, use it
            if (!forceFetch && val) { 
                resolve(val);
                return;
            }

            // Get and cache
            dis.fs.doc(`users/${uid}`).get().then(doc => {

                let newVal = uid; // Default matching UID in case display name is not set

                if (doc.exists && doc.data()) {
                    newVal = doc.data().displayName;
                }

                let expiresIn = 1/48; // Lib will take Number as days; 1/48 = 30 min.
                Cookies.set(key, newVal, { expires: expiresIn }); 

                resolve(newVal);
            })
            .catch(error => {
                reject(error.message);
            });
        });
    }
}

export default BackendClient;


// WEBPACK FOOTER //
// ./src/BackendClient.js